import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { Typography } from "@mui/material"
import IconBox from "../../../components/IconBox"
import UIIcon from "../../../components/UIIcon"
import { RootState } from "../../../store/store"
import { resetSlice } from "../../../store/slices/c2bSlice"
import { resetSteps } from "../../../store/slices/routingSlice/routingSlice"
import { ROUTES_PATHS, RUBLE, RUBLE_TEXT } from "../../../utils/constants"
import { formatAmount } from "../../../utils/formatters"
import { sendCustomEvent } from "../../../events/events"
import {
  ActionButton,
  ContentContainer,
  MessageContainer,
  Title,
} from "./styled"
import { Amount, BottomContainer, DetailLabel, MerchantBrandName } from "../Payment/styled"
import { useGetSbpOutcomePaymentStatus } from "../../../api/hooks/useGetSbpOutcomePaymentStatus"
import {
  AccordionBody,
  AccordionHeader,
  DetailContainer,
  DetailsContainer,
  DetailsContainerTextOverflow,
  DetailValue,
  StyledAccordion,
  StyledDivider,
} from "../../SbpOutcomeTransfer/Status/styled"
import { getTimezone } from "../../../utils/datetime"
import { useGetUserInfo } from "../../../api/hooks/useGetUserInfo"

const C2BPushSuccess = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const qrcInfo = useSelector((state: RootState) => state.c2bPayment.qrcInfo)
  const outcomePaymentId = useSelector((state: RootState) => state.c2bPayment.outcomePaymentId)
  const { data: outcomePaymentData } = useGetSbpOutcomePaymentStatus(outcomePaymentId, false)
  const { data: userInfo } = useGetUserInfo()

  const handleDone = () => {
    sendCustomEvent({ eventName: "quit" })
    dispatch(resetSlice())
    dispatch(resetSteps())
    navigate(`/${ROUTES_PATHS.main}`)
  }

  return (
    <ContentContainer>
      <MessageContainer>
        <IconBox size="lg" color="yellow">
          <UIIcon iconName="check" size={45} />
        </IconBox>
        <Title variant="h3">Покупка оплачена</Title>
        <Amount sx={{ alignSelf: "center" }}>
          {formatAmount(outcomePaymentData?.amount || 0)} {RUBLE}
        </Amount>
        <DetailLabel sx={{ alignSelf: "center" }}>
          Без комиссии
        </DetailLabel>
        <MerchantBrandName sx={{ textAlign: "center" }}>
          {qrcInfo?.merchantBrandName}
        </MerchantBrandName>
        <StyledDivider sx={{ width: "100%" }} />
        {outcomePaymentData && (  
        <StyledAccordion>
          <AccordionHeader
            expandIcon={<UIIcon iconName="arrowDown" />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography variant="h4">Подробнее об операции</Typography>
          </AccordionHeader>
          <AccordionBody>
            <DetailsContainer sx={DetailsContainerTextOverflow}>
              <DetailContainer>
                <DetailLabel>Дата и время операции</DetailLabel>
                <DetailValue>{getTimezone(outcomePaymentData?.createdOn)}</DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Счет списания</DetailLabel>
                <DetailValue>{userInfo?.bankAccountNumber}</DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Сумма операции</DetailLabel>
                <DetailValue>{formatAmount(outcomePaymentData?.amount)}</DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Валюта операции</DetailLabel>
                <DetailValue>{RUBLE_TEXT}</DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Наименование ТСП</DetailLabel>
                <DetailValue>{outcomePaymentData?.recipient?.merchantBrandName}</DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Наименование юридического лица или индивидуального предпринимателя</DetailLabel>
                <DetailValue>{outcomePaymentData?.recipient?.merchantBrandName}</DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Назначение платежа</DetailLabel>
                <DetailValue>{outcomePaymentData?.description}</DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Идентификатор операции СБП</DetailLabel>
                <DetailValue>{outcomePaymentData?.operationNumber}</DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Идентификатор операции РНКО &quot;Единая касса&quot;</DetailLabel>
                <DetailValue>{outcomePaymentData?.outcomePaymentId}</DetailValue>
              </DetailContainer>
            </DetailsContainer>
          </AccordionBody>
        </StyledAccordion>
        )}
      </MessageContainer>
      <BottomContainer>
        <UIIcon iconName="sbpExtIcon" size={64} />
        <ActionButton variant="contained" fullWidth onClick={handleDone}>
          Готово
        </ActionButton>
      </BottomContainer>
    </ContentContainer>
  )
}

export default C2BPushSuccess
